// Round-trip URL search params <-> typed filter object for
// /management/sales-goals. Used by the route's `validateSearch` and consumed
// via `useSearch` in the sales-goals table widget.

export type SalesGoalsSearch = {
  // Raw strings — the backend's findSalesGoalsInput accepts `year:
  // z.array(z.string()).optional()` and casts to int internally.
  year?: string[];
  accountId?: string[];
  groupId?: string[];
  page?: number;
};

const asStringArray = (v: unknown): string[] | undefined =>
  Array.isArray(v)
    ? v.filter((x): x is string => typeof x === 'string')
    : undefined;

export const validateSalesGoalsSearch = (
  input: Record<string, unknown>
): SalesGoalsSearch => ({
  year: asStringArray(input.year),
  accountId: asStringArray(input.accountId),
  groupId: asStringArray(input.groupId),
  page: typeof input.page === 'number' ? input.page : undefined,
});
